module.exports = __webpack_public_path__ + "media/images/icons/document-2871e9c3623495fab967a55197a95c0e.png";